module.exports = __webpack_public_path__ + "packs/media/images/palestraBoulder2-da533adda54f56e459756f3fa05d3cbe.jpg";